<section class="search-page" [ngClass]="{'luxury':currentShownListingType===ListingType.LUXURY, 'commercial': currentShownListingType===ListingType.COMMERCIAL, 'residential': currentShownListingType === ListingType.RESIDENTIAL}">
  <div [jsonSchema]="schemas"></div>
  <div class="filters">
    <app-filters-search [setSearchType]="searchType" (onPaginationReset)="pagination.pageNumber = 0" (onFiltersChange)="doSearch($event)"
      [currentShownListingType]="currentShownListingType"></app-filters-search>
  </div>
  <h1>{{h1Text}}</h1>
  <div class="search-content-wrapper is-flex is-flex-row full-width">
    <app-gallery-view class="full-width" [items]="items" (infiniteScrolled)="getNewItems(pagination.pageNumber + 1, true)" [pagination]="pagination" (changePage)="getNewItems($event)"
      [isFetchingItems]="isFetchingItems" [shouldHideSorting]="true">
      <ng-container *ngIf="searchType === SearchType.OFFICE">
        <app-office-card *ngFor="let office of items; let i = index; trackBy: Office.trackBy"
        [office]="office" (onOfficeEmailClicked)="showContactForm(office)" [style.order]="i<2?-2:0"></app-office-card>
      </ng-container>
      <ng-container *ngIf="searchType === SearchType.AGENT">
        <app-agent-card *ngFor="let agent of items; let i = index; trackBy: Agent.trackBy"
        [agent]="agent" [includeTitle]="true" (onAgentEmailClicked)="showContactForm(agent)" [style.order]="i<2?-2:0"
        [enableAnalyticsEventTriggering]="isPopularAgentPage"
        ></app-agent-card>
      </ng-container>
      <app-ad-card class="grid-cell-ad" [ad]="ad" [class.empty-list]="!items || !items.length"></app-ad-card>
    </app-gallery-view>

  </div>

  <app-logo></app-logo>
  <app-modal [shouldShowModal]="showContactLeadForm" (closeModal)="showContactLeadForm = false" [allowOutsideClickToClose]="false"
    [isFullHeight]="true" [templateRef]="contactAgentModalRef">
  </app-modal>
  <ng-template #contactAgentModalRef>
    <app-contact-agent [contactForm]="contactForm" [isFixed]="false" [leadInfo]="leadInfo" (requestSent)="showContactLeadForm = false; showRequestSent = true"
      [listingCategory]="currentShownListingType"></app-contact-agent>
  </ng-template>
  <app-request-sent *ngIf="showRequestSent" (onClose)="showRequestSent = false" [nameToDisplay]="nameToDisplayForRequestSent"></app-request-sent>

</section>
